module.exports = __webpack_public_path__ + "static/media/to-do.1eb9851a.png";